<p-confirmDialog key="confirmadd" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="ItemBorder">
	<h4 style="text-align: center; margin-bottom: 15px">Add Group Reminder</h4>

	<!--Group Info-->
	<div class="Grid2Col" style="grid-column-gap: 5px">
		<label>Group:</label>
		<label class="InfoText">{{ GroupName }}</label>
	</div>

	<!--Mode-->
	<div class="Grid4Col">
		<input [disabled]="IsLoading() == true" id="New" value="New" name="ModeOption" [(ngModel)]="ModeOption" type="radio" class="RAD" />
		<label for="New">Create New Reminder</label>

		<input
			[disabled]="IsLoading() == true"
			id="Existing"
			value="Existing"
			name="ModeOption"
			[(ngModel)]="ModeOption"
			type="radio"
			class="RAD"
			style="margin-left: 15px"
		/>
		<label for="Existing">Existing Reminder</label>
	</div>
</div>

<!--Existing Reminder-->
<div *ngIf="ModeOption == 'Existing'" class="ItemBorder TopMargin Grid2Col">
	<label>Reminder:</label>
	<select
		[disabled]="IsLoading() == true"
		class="form-control"
		name="SelectedStationReminderAlert"
		[style.color]="SelectedStationReminderAlert.MessageFontColor"
		[(ngModel)]="SelectedStationReminderAlert"
	>
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstStationReminderAlert" [style.color]="o.MessageFontColor" [ngValue]="o">{{ o.Message }}</option>
	</select>

	<label>Type:</label>
	<label class="InfoText">{{ SelectedStationReminderAlert?.AlertTypeDesc }}</label>

	<label *ngIf="SelectedStationReminderAlert?.AlertType == 3">Date Range:</label>
	<label *ngIf="SelectedStationReminderAlert?.AlertType == 3" class="InfoText">{{ SelectedStationReminderAlert?.DateRangeDesc }}</label>

	<label>Entry Scanning:</label>
	<label>
		<i *ngIf="SelectedStationReminderAlert?.EntryMode == true" class="fa fa-check-square IconFont SuccessColor"></i>
		<i *ngIf="SelectedStationReminderAlert?.EntryMode == false" class="fa fa-times-circle IconFont ErrorColor"></i>
	</label>

	<label>Exit Scanning:</label>
	<label>
		<i *ngIf="SelectedStationReminderAlert?.ExitMode == true" class="fa fa-check-square IconFont SuccessColor"></i>
		<i *ngIf="SelectedStationReminderAlert?.ExitMode == false" class="fa fa-times-circle IconFont ErrorColor"></i>
	</label>

	<label>Meal Scanning:</label>
	<label>
		<i *ngIf="SelectedStationReminderAlert?.MealMode == true" class="fa fa-check-square IconFont SuccessColor"></i>
		<i *ngIf="SelectedStationReminderAlert?.MealMode == false" class="fa fa-times-circle IconFont ErrorColor"></i>
	</label>

	<label>Access Mode Scanning:</label>
	<label>
		<i *ngIf="SelectedStationReminderAlert?.AccessMode == true" class="fa fa-check-square IconFont SuccessColor"></i>
		<i *ngIf="SelectedStationReminderAlert?.AccessMode == false" class="fa fa-times-circle IconFont ErrorColor"></i>
	</label>

	<label>Time Stamp Scanning:</label>
	<label>
		<i *ngIf="SelectedStationReminderAlert?.TimeStampMode == true" class="fa fa-check-square IconFont SuccessColor"></i>
		<i *ngIf="SelectedStationReminderAlert?.TimeStampMode == false" class="fa fa-times-circle IconFont ErrorColor"></i>
	</label>

	<label>Enter Event:</label>
	<label>
		<i *ngIf="SelectedStationReminderAlert?.EventEntryMode == true" class="fa fa-check-square IconFont SuccessColor"></i>
		<i *ngIf="SelectedStationReminderAlert?.EventEntryMode == false" class="fa fa-times-circle IconFont ErrorColor"></i>
	</label>

	<label>Exit Event:</label>
	<label>
		<i *ngIf="SelectedStationReminderAlert?.EventExitMode == true" class="fa fa-check-square IconFont SuccessColor"></i>
		<i *ngIf="SelectedStationReminderAlert?.EventExitMode == false" class="fa fa-times-circle IconFont ErrorColor"></i>
	</label>

	<label>Notifies Parent Portal:</label>
	<label>
		<i *ngIf="SelectedStationReminderAlert?.ParentPortalSendNotification == true" class="fa fa-check-square IconFont SuccessColor"></i>
		<i *ngIf="SelectedStationReminderAlert?.ParentPortalSendNotification == false" class="fa fa-times-circle IconFont ErrorColor"></i>
	</label>

	<label>Notifies Student Portal:</label>
	<label>
		<i *ngIf="SelectedStationReminderAlert?.StudentPortalSendNotification == true" class="fa fa-check-square IconFont SuccessColor"></i>
		<i *ngIf="SelectedStationReminderAlert?.StudentPortalSendNotification == false" class="fa fa-times-circle IconFont ErrorColor"></i>
	</label>

	<label>Notifies Staff Portal:</label>
	<label>
		<i *ngIf="SelectedStationReminderAlert?.StaffPortalSendNotification == true" class="fa fa-check-square IconFont SuccessColor"></i>
		<i *ngIf="SelectedStationReminderAlert?.StaffPortalSendNotification == false" class="fa fa-times-circle IconFont ErrorColor"></i>
	</label>

	<label>Add to Students Automatically:</label>
	<input type="checkbox" class="CHK" [(ngModel)]="AddAutomatically" />
</div>

<!--New Reminder-->
<div *ngIf="ModeOption == 'New'" class="ItemBorder TopMargin">
	<div class="column-group">
		<div class="column1">
			<!--Message-->
			<div class="column-item">
				<div>
					<label class="column-item-label">Message:</label>
				</div>

				<div style="margin-left: 10px">
					<p-colorPicker [(ngModel)]="Messagecolor" [disabled]="IsLoading() == true"></p-colorPicker>
				</div>

				<div style="margin-left: 2px">
					<input
						type="text"
						pInputText
						[(ngModel)]="Message"
						[style.color]="Messagecolor"
						maxlength="100"
						style="width: 640px"
						[disabled]="IsLoading() == true"
					/>
				</div>

				<div>
					<label class="column-item-label">Max 100 characters</label>
				</div>
			</div>

			<!--Sound-->
			<div class="column-item">
				<div>
					<label class="column-item-label">Sound:</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedSoundSelector"
						style="font-size: smaller"
						[disabled]="IsLoading() == true"
						[(ngModel)]="SelectedSound"
						(ngModelChange)="onSoundChange($event)"
					>
						<option *ngFor="let r of lstSoundItems" [ngValue]="r">
							{{ r.SoundFile }}
						</option>
					</select>
				</div>

				<div style="margin-left: 5px">
					<button class="btn btn-primary btn-sm" style="margin-left: 5px" (click)="onPlay()" [disabled]="IsLoading() == true">Play</button>
					<button class="btn btn-primary btn-sm" style="margin-left: 5px" (click)="onStop()" [disabled]="IsLoading() == true">Stop</button>
				</div>

				<!-- 				   -->
				<!-- Display When Busy -->
				<!-- 				   -->
				<div style="margin-left: 15px; width: 20px" [style.display]="IsLoading() == true ? 'block' : 'none'">
					<img class="busy-img" src="assets/images/loading.gif" />
				</div>
			</div>

			<!--Alert Type-->
			<div class="column-item">
				<div>
					<label class="column-item-label">Frequency:</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<select
						class="form-control"
						name="SelectedAlertType"
						style="font-size: smaller"
						[(ngModel)]="SelectedAlertTypeID"
						[disabled]="IsLoading() == true"
					>
						<option *ngFor="let r of lstAlertType" [ngValue]="r.ID">
							{{ r.Desc }}
						</option>
					</select>
				</div>
			</div>

			<div class="column-item" *ngIf="SelectedAlertTypeID == 3">
				<div>
					<label class="column-item-label">Start Date:</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="StartDate" name="StartDate" [disabled]="IsLoading() == true"></p-calendar>
				</div>

				<div>
					<label class="column-item-label">End Date:</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="EndDate" name="EndDate" [disabled]="IsLoading() == true"></p-calendar>
				</div>
			</div>

			<!--Priority-->
			<div class="column-item">
				<div>
					<label class="column-item-label">Priority:</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<select class="form-control" name="Priority" style="font-size: smaller" [(ngModel)]="Priority" [disabled]="IsLoading() == true">
						<option *ngFor="let r of lstPriority" [ngValue]="r.ID">
							{{ r.Desc }}
						</option>
					</select>
				</div>
			</div>

			<div class="column-item">
				<div>
					<label class="column-item-label">Scan Station Modes:</label>
				</div>

				<div style="margin-left: 10px">
					<div class="ScanModeGrid">
						<input id="EntryMode" class="CHK" type="checkbox" [(ngModel)]="EntryMode" />
						<label for="EntryMode">Entry Mode</label>

						<input id="ExitMode" class="CHK InnerColumn" type="checkbox" [(ngModel)]="ExitMode" />
						<label for="ExitMode">Exit Mode</label>

						<input id="MealMode" class="CHK InnerColumn" type="checkbox" [(ngModel)]="MealMode" />
						<label for="MealMode">Meal Mode</label>

						<input id="AccessMode" class="CHK" type="checkbox" [(ngModel)]="AccessMode" />
						<label for="AccessMode">Access Mode</label>

						<input id="TimeStampMode" class="CHK InnerColumn" type="checkbox" [(ngModel)]="TimeStampMode" />
						<label for="TimeStampMode">Time Stamp Mode</label>

						<input id="EventEntryMode" class="CHK InnerColumn" type="checkbox" [(ngModel)]="EventEntryMode" />
						<label for="EventEntryMode">Event Mode (Entry)</label>

						<input id="EventExitMode" class="CHK" type="checkbox" [(ngModel)]="EventExitMode" />
						<label for="EventExitMode">Event Mode (Exit)</label>
					</div>
				</div>
			</div>

			<div class="column-item">
				<div>
					<label class="column-item-label">Notify Apps:</label>
				</div>

				<div style="margin-left: 10px">
					<div class="ScanModeGrid">
						<input id="ParentPortalSendNotification" class="CHK" type="checkbox" [(ngModel)]="ParentPortalSendNotification" />
						<label for="ParentPortalSendNotification">Parent Portal</label>

						<input id="StudentPortalSendNotification" class="CHK InnerColumn" type="checkbox" [(ngModel)]="StudentPortalSendNotification" />
						<label for="StudentPortalSendNotification">Student Portal</label>

						<input id="StaffPortalSendNotification" class="CHK InnerColumn" type="checkbox" [(ngModel)]="StaffPortalSendNotification" />
						<label for="StaffPortalSendNotification">Staff Portal</label>
					</div>
				</div>
			</div>

			<div class="column-item">
				<div>
					<label class="column-item-label">Add to Students Automatically:</label>
				</div>

				<div style="margin-left: 10px">
					<div class="ScanModeGrid">
						<input type="checkbox" class="CHK" [(ngModel)]="AddAutomatically" />
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
